import React from "react";
import "./About.css";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import PassportImage from "../../Assest/Image/passportSize.jpeg";
import useScrollReveal from "../../hooks/useScrollReveal";

const About = () => {
  const leftRef = useScrollReveal({ threshold: 0.05 });
  const rightRef = useScrollReveal({ threshold: 0.05 });

  const [text] = useTypewriter({
    words: [
      "Full-Stack Software Engineer",
      "React.js Specialist",
      "Node.js Developer",
      "AWS Cloud Developer",
    ],
    loop: {},
    typeSpeed: 80,
    deleteSpeed: 50,
  });

  return (
    <div className="about" id="about">
      {/* Left — Image */}
      <div className="about-left reveal-left" ref={leftRef}>
        <div className="about-img-wrapper">
          <div className="about-img-border" />
          <div className="about-img-inner">
            <img src={PassportImage} alt="Abhinav Kumar Pathak" />
          </div>
          <div className="exp-badge">
            <span className="exp-badge-number">2+</span>
            <span className="exp-badge-label">Years Exp.</span>
          </div>
        </div>
      </div>

      {/* Right — Content */}
      <div className="about-right reveal-right" ref={rightRef}>
        <span className="about-tag">About Me</span>

        <h2 className="about-title">
          Crafting <span>Scalable</span> & High-Performance Web Apps
        </h2>

        <p className="about-subtitle">
          <span>{text}</span>
          <Cursor cursorStyle="|" />
        </p>

        <p className="about-desc">
          Full-Stack Software Engineer with 2 years of professional experience
          delivering production-grade web applications used by 5K+ users. I
          specialize in React.js, Node.js, PostgreSQL, and AWS — building
          everything from real-time chat systems and WebRTC video platforms to
          AI-powered voice automation and cloud infrastructure. I care deeply
          about clean architecture, performance, and shipping things that
          actually work at scale.
        </p>

        {/* Quick facts */}
        <div className="about-facts">
          <div className="about-fact-item">
            <span className="about-fact-number">5K+</span>
            <span className="about-fact-label">Users Served</span>
          </div>
          <div className="about-fact-divider" />
          <div className="about-fact-item">
            <span className="about-fact-number">30–40%</span>
            <span className="about-fact-label">Cost Reduction</span>
          </div>
          <div className="about-fact-divider" />
          <div className="about-fact-item">
            <span className="about-fact-number">8.4</span>
            <span className="about-fact-label">CGPA</span>
          </div>
        </div>

        <div className="about-info-grid">
          <div className="about-info-item">
            <span className="about-info-label">Location</span>
            <span className="about-info-value">India</span>
          </div>
          <div className="about-info-item">
            <span className="about-info-label">Email</span>
            <span className="about-info-value">abhinavpathak9984@gmail.com</span>
          </div>
          <div className="about-info-item">
            <span className="about-info-label">Phone</span>
            <span className="about-info-value">+91-9682906846</span>
          </div>
          <div className="about-info-item">
            <span className="about-info-label">Education</span>
            <span className="about-info-value">B.Tech CSE — 8.4 CGPA</span>
          </div>
        </div>

        {/* Experience */}
        <div className="experience-section">
          <p className="exp-title">Experience</p>
          <div className="exp-timeline">
            {/* Current Role — Eminence Technology */}
            <div className="exp-card exp-card-current">
              <div className="exp-card-header">
                <div className="exp-company-group">
                  <span className="exp-company">Eminence Technology</span>
                  <span className="exp-current-badge">Current Role</span>
                </div>
                <span className="exp-period">July 2026 – Present</span>
              </div>
              <p className="exp-role">Software Developer</p>
              <ul className="exp-points">
                <li>Developing and scaling modern full-stack web applications using React.js, Node.js, and cloud services</li>
                <li>Architecting responsive user interfaces and building robust backend API integrations</li>
                <li>Optimizing application performance, query speeds, and scalable web architecture</li>
              </ul>
            </div>

            {/* Previous Role — Code Garage Tech */}
            <div className="exp-card">
              <div className="exp-card-header">
                <span className="exp-company">Code Garage Tech</span>
                <span className="exp-period">May 2024 – July 2026</span>
              </div>
              <p className="exp-role">Software Developer</p>
              <ul className="exp-points">
                <li>Designed AWS EC2 infrastructure with Auto Scaling & RDS/Aurora supporting 5K+ users</li>
                <li>Implemented time-bound EC2 lifecycle automation (3-hour sessions), reducing costs by 30–40%</li>
                <li>Developed backend APIs using Node.js & Python for WhatsApp messaging, SMS, and call automation</li>
                <li>Collaborated on frontend development using React.js while integrating backend APIs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
